module.exports = __webpack_public_path__ + "5747fea979f0d9d4cd304387832c9a10.jpg";